<template>
  <div class="loginmain">
    <div class="loginhead">
      <h1></h1>
    </div>

    <!--登录div-->
    <div class="login_box"  v-if="logDiv">
      <div class="login">
        <el-tabs >
        <div id="classLogin">
          <el-radio-group >
            <span style="color: #409eff;font-weight: bold;font-size: 25px">建设项目选址空间分析</span>
          </el-radio-group>
        </div>
        <div  class="loginfromDiv">
       <!--   <div class="login-type">
            <template>
              <el-tabs v-model="radio2" @tab-click="handleClick" stretch="true">
                <el-tab-pane label="测绘单位" name='2'></el-tab-pane>
                <el-tab-pane label="建设单位" name='5'></el-tab-pane>
                <el-tab-pane label="设计单位" name='4'></el-tab-pane>
              </el-tabs>
            </template>
          </div>-->
        <el-form :model="user" :rules="rules" ref="ruleForm">
          <el-form-item prop="account">
          <el-input v-model="user.account"  type="text" placeholder="手机号"/>
          </el-form-item>
          <el-form-item prop="password" v-if="dllx!==1">
            <el-input v-model="user.password"  type="password" placeholder="密码" />
          </el-form-item>
          <el-form-item v-if="dllx===1">
            <el-input v-model="user.password"  type="text" placeholder="验证码" style="position: absolute;left: 0" ></el-input>
            <el-button plain style="position: absolute;right: 0" size="small" :disabled="isSendMsg" @click="sendMsg" >{{smgButName}}</el-button>
            <br>
          </el-form-item>

         <!-- <el-form-item prop="loginCode">
            <el-row :gutter="20">
              <el-col :span="14">
                <el-input placeholder="请输入验证码" v-model="user.loginCode" @keyup.enter.native="loginSubmit()">
                </el-input>
              </el-col>
              <el-col :span="8">
                <div style="width: auto;position: fixed">
                  <v-sidentify ref="sident" ></v-sidentify>
                </div>
              </el-col>
            </el-row>
          </el-form-item>-->


        <!--  <div >
              <span>
                  没有账号？
                  <a @click="userRegister">立即注册账号</a>
                      &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;&nbsp;  &nbsp;&nbsp;  &nbsp;&nbsp;  &nbsp; &nbsp;&nbsp;  &nbsp;&nbsp;
                  <a @click="forgetPassword">忘记密码?</a>
              </span>
          </div>-->
          <br/>
          <input value="登录" style="width:100%;background-color: #409EFF" type="button"  @click="loginSubmit">
         <!-- <div style="text-align: right;margin-top: 10px">
          <a href="./static/多测合一操作流程（外网）.docx" target="_blank">使用手册</a>
          </div>-->
        </el-form>
        </div>
        </el-tabs>
      </div>
    </div>

    <!--找回密码div-->

    <!--登录div-->
    <div class="pass_box" v-if="resPasswordDiv">
      <div class="login">
        <el-tabs >
          <div class="czLogin">
            <el-radio-group >
              <span style="color: #409eff;font-weight: bold;font-size: 25px"><img src="../../../assets/mmcz.png"/>   &nbsp;密码重置</span>
            </el-radio-group>
          </div>
          <div class="login-type">
            <template>
              <el-tabs v-model="mmtype" @tab-click="handleClick" stretch="true">
                <el-tab-pane label="测绘单位" name='2'></el-tab-pane>
                <el-tab-pane label="建设单位" name='5'></el-tab-pane>
                <el-tab-pane label="设计单位" name='4'></el-tab-pane>
              </el-tabs>
            </template>
          </div>
          <el-form :model="pass" :rules="respasruleForm" ref="respasruleForm">
            <el-form-item prop="upjgdm">
              <el-input v-model="pass.upjgdm"  type="text" placeholder="请输入注册机构代码"/>
            </el-form-item>
            <el-form-item prop="zcsjh">
              <el-input v-model="pass.zcsjh"  type="text" placeholder="请输入注册手机号"/>
            </el-form-item>
            <el-form-item prop="yzm">
              <el-input v-model="pass.yzm" placeholder="请输入手机验证码" maxlength="11" clearable
                        :style="{width: '63%'}">
              </el-input>
              <el-button type="primary" :disabled="isSendMsg" @click="sendMsg" style="width:34%">{{smgButName}}</el-button>
            </el-form-item>
            <el-form-item prop="xpassword">
              <el-input v-model="pass.xpassword"  type="password" placeholder="请输入新密码"/>
            </el-form-item>
            <el-form-item prop="rpassword">
              <el-input v-model="pass.rpassword"  type="password" placeholder="请再次输入密码"/>
            </el-form-item>
            <input value="确定" style="width:100%;background-color: #409EFF" type="button"  @click="updatePassWord">
          </el-form>
          <div style="margin-top: 5px">
          <a @click="goLogin" style="float: right;margin-right: 1px;">返回登录</a>
          </div>
        </el-tabs>
      </div>
    </div>





  </div>
</template>

<script>
  import API from '../../../api/ApiConfig'
  import {ajaxPost} from '../../../util/AjaxhttpRequest'
  import $ from 'jquery'
  import Cookie from 'cookies-js'

  import {isEmpty} from '../../../util/utils'
  import {BASE_URL} from '../../../api/url'
  import identifyCode from "../../../assets/js/identifyCode"

  export default {
    name: 'UserLogin',
    components:{
      identifyCode
    },
    data () {
      const validateVerifycode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'))
        } else if (value.toLowerCase() !== this.$refs.sident.drawTextCont.toLowerCase()) {
          console.log('validateVerifycode:', this.$refs.sident.drawTextCont)
          callback(new Error('验证码不正确!'))
        } else {
          callback()
        }
      };
      return {
        dllx:1,
        mmtype:'2',
        isSendMsg: false,
        smgButName:"发送验证码",
        logDiv:true,
        resPasswordDiv:false,
        radio2: '2',
        loading: true,
        user: {
          account: '',
          password: '',
          loginCode: ''
        },
        //找回密码实体
        pass:{
          xpassword:''
        },
        rules: {
          account: [
            {required: true, message: '请输入正确的手机号码',
              pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
              trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'}
          ],
          loginCode: [
            {required: true, trigger: 'blur',validator: validateVerifycode }
          ]
        },
        respasruleForm: {
          upjgdm: [
            {required: true, message: '请输入注册机构代码', trigger: 'blur'}
          ],
          zcsjh: [
            {required: true, message: '请输入注册时填写的手机号', trigger: 'blur'}
          ],
          yzm: [
            {required: true, message: '请输入验证码', trigger: 'blur'}
          ],
          xpassword: [{
            required: true,
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
            message: '密码需包含数字、字母两种元素，且密码位数为6-16位',
            trigger: 'blur'
          }],
          rpassword: [
            {required: true, message: '请输入确认密码', trigger: 'blur'}
          ],
        },

      }
    },
    mounted () {

    },created() {
      var _this = this;
      document.onkeydown = function (e) {
        let key = window.event.keyCode;
        if (key == 13) {
          _this.loginSubmit();
        }
      };

    },
    methods: {
      //发送短信操作
      sendMsg() {
        var self=this;
        var phone = this.user.account
        if (!(/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(phone))) {
          self.$message.error("请输入正确的手机号码!");
          return false;
        }

        var parm = ['','WwXmJcpt',phone,'kjfxSms','kjfxMsg','空间分析登录短信验证'];
        ajaxPost(API.kjfxUserProvider,"pushCode",parm).then(result=>{

          var res = result.result;
          var count = parseInt(res);
          if (count>=3) {
            self.$message.warning('手机号码：'+phone+'在当天已经发送短信'+count+'次，请慎重发送，当天最多发送5次！');
          }
          self.isSendMsg=true;
          var i=60;
          var countdown = setInterval(function () {
            i--;
            self.smgButName="("+i+")秒后重试"
            if(i <= 0){
              clearInterval(countdown);
              self.smgButName="发送短信"
                self.isSendMsg=false;
            }
          }, 1000);
        }).catch(err=>{
          this.$message.error(err);
        })
      },
      handleClick(tab, event) {
        var i=this.radio2
        console.log(tab, event);
      },
      //忘记密码
      forgetPassword(){
        this.logDiv=false;
        this.resPasswordDiv=true;
        },
      goLogin(){
        this.$router.go(0);
      },
      //修改密码
      updatePassWord(){
        var self=this;
        this.$refs.respasruleForm.validate((valid) => {
            if (!valid){
              return
            }
        var  xpassword=      this.$md5(self.pass.xpassword);
        var  rpassword=      this.$md5(self.pass.rpassword);
        if(xpassword!=rpassword) {
          self.$message.warning('俩次输入密码不一致');
          return; false;
        }
          const loading = this.$loading({
            lock: true,
            text: '正在处理中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
        //提交后台
          var param = [];
          param.push(self.pass.upjgdm); //手机号
          param.push(self.pass.zcsjh); //手机号
          param.push(self.pass.yzm);//验证码
          param.push(xpassword); //新密码
          param.push(self.mmtype); //机构类型
          $.ajax({
            type: 'POST',
            url: BASE_URL,
            data: {interfaceName: 'antu.dchyww.provider.login.UserLoginProvider', methodName: 'updatePassWord', args: param},
            success: function (data) {
              loading.close();
              if (data.status === '0') {
                self.goLogin();
                self.$message.success("重置密码成功！");
              } else {
                self.$message.error(data.message)

              }
            },
            error: function (jqXHR) {
              loading.close();
              self.$message.error('无法连接服务器！请检查网络')
            }
          })
      })
      },
      loginSubmit () {
        let self = this;
        /*
        if(that.radio2==''){
          that.$message.warning("请选择登录类型！");
          return;
        }*/
        this.$refs.ruleForm.validate((valid) => {
          if (!valid){
            return
          }
          if (this.dllx===1){
            var flag=false;
            var self = this;
            if(!self.user.password) {
              self.$message.error('短信验证码不能为空!');
              return false;
            }
            var parm = ['','WwXmJcpt',self.user.account,self.user.password];
            ajaxPost(API.kjfxUserProvider,"checkSmgCode",parm).then(result=>{
            let res=JSON.parse(result);
              Cookie.set('dlzh',res.account)
              Cookie.set('dllx',res.dllx)
              Cookie.set('wwJcptToken',res.token)
              this.$router.push({
               path: "/KjfxPage",
                query:{
                 loginType:'local'
                }
              });
            }).catch(err=>{
              self.$message.error(err);
            })
          } else {
            ajaxPost(API.kjfxUserProvider,"getLogin",["Ys","123.com",1]).then(data=>{
              console.log(data)
              /*  Cookie.set('kjfxToken', encodeURIComponent(data.token), {path: '/'});
                Cookie.set('jgdm', data.jgdm, {path: '/'});
                Cookie.set('dlzh', data.dlzh, {path: '/'});
                Cookie.set('dwmc', data.dwmc, {path: '/'});
                Cookie.set('jglx', data.jglx, {path: '/'});*/
              // that.getMenu(data.jglx);
              this.$router.push("/KjfxPage");
            }).catch(err=>{
              this.$message.error(err);
            })
          }


       /* var param = [];
        param.push(this.user.account);
        param.push(this.$md5(this.user.password));
        param.push(this.radio2);
        $.ajax({
          type: 'POST',
          url: BASE_URL,
          data: {interfaceName: 'antu.dchyww.provider.login.UserLoginProvider', methodName: 'userLogin', args: param},
          success: function (data) {
            if (data.status === '0') {
              data = JSON.parse(data.result);
              that.getATPToken();
              //登录成功存储用户信息
              Cookie.set('kjfxToken', encodeURIComponent(data.token), {path: '/'});
              Cookie.set('jgdm', data.jgdm, {path: '/'});
              Cookie.set('dlzh', data.dlzh, {path: '/'});
              Cookie.set('dwmc', data.dwmc, {path: '/'});
              Cookie.set('jglx', data.jglx, {path: '/'});
              that.getMenu(data.jglx);
            } else {
              that.$message.error(data.message)
            }
          },
          error: function (jqXHR) {
            that.$message.error('无法连接服务器！请检查网络')
          }*/
      })
      },
      getMenu: function (jglx) {
        var self = this;
        var param = [];
        param.push(Cookie.get('kjfxToken'));
        param.push(jglx);
        $.ajax({
          type: 'POST',
          url: BASE_URL,
          async: false,
          data: {interfaceName: 'antu.dchyww.provider.login.UserLoginProvider', methodName: 'getUserMenu', args: param},
          success: function (data) {
            console.info(data)
            if (data.status == 0) {
              self.$store.commit('setmenuList',JSON.parse(data.result));
              //跳转
              self.$router.push("/jcxx");
            } else {
              self.$message.error(data.message)
            }
          },
          error: function (jqXHR) {
            self.loading = false
            self.$message.error('无法连接服务器！请检查网络')
          }
        })
      }
      ,userRegister:function () {
        const self =this;
          this.$router.push("/userRegister");
      },
      getATPToken:function(){
    var self = this;
    var param=[];
    param.push('superAtp');
    param.push('#super&Atp@123');
    var token = "";
    $.ajax({
      type: "POST",
      url: BASE_URL,
      async: false,
      data: {
        interfaceName: "antu.atp.provider.tokenv2.SecretKeyProvider",
        methodName: "getToken",
        args: param
      },
      success: function (data) {
        Cookie.set('atptoken', data.result, {path: '/'})
      }
    })
    return token;
  },





    }
  }
</script>

<style scoped>
  .loginmain {
    background: url('../../../assets/login_bj.jpg');
    background-size: 100% 100%;
    height: 100%;
    position: fixed;
    width: 100%;
    overflow: hidden;
  }

  .loginhead {
    height:115px;
    width: 800px;
    margin: 3% auto;
    background-image: url('../../../assets/toplogo.png');
    background-size: 100% 100%;
    padding-top: 100px;
  }

  * {
    font: 13px/1.5 '微软雅黑';
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -box-sizing: border-box;
   /* padding: 0;
    margin: 0;*/
    list-style: none;
    box-sizing: border-box;
  }

  a {
    color: #27A9E3;
    text-decoration: none;
    cursor: pointer;
  }

  .login_box {
    width:30%;
    background-color: #93defe;
    background-size: cover;
    margin: 3% auto;
    /*height: 330px;*/
    height: 50%;
  }
  .pass_box {
    width:30%;
    background-color: #93defe;
    background-size: cover;
    margin: 3% auto;
    /*height: 330px;*/
    height: 59%;
  }

  .login {
    height: 100%;
    width: 100%;
    padding: 5px 50px 50px 50px;
    background-color: #ffffff;
    border-radius: 6px;
    box-sizing: border-box;
    float: right;
    position: relative;
    margin: 0 auto;
  }
  #classLogin{
    padding-bottom: 30px;
    text-align: center;
  }
  .czLogin{
    padding-bottom: 10px;
  }

  .login_name p {
    width: 100%;
    text-align: center;
    font-size: 18px;
    color: #444;
    padding: 10px 0 20px;
  }

  .login_logo img {
    width: 60px;
    height: 60px;
    display: inline-block;
    vertical-align: middle;
  }

  input[type=text], input[type=file], input[type=password], input[type=email], select {
    border: 1px solid #DCDEE0;
    vertical-align: middle;
    border-radius: 3px;
    height: 50px;
    padding: 0px 16px;
    font-size: 14px;
    color: #555555;
    outline: none;
    width: 100%;
    margin-bottom: 15px;
    line-height: 50px;
    color: #888;
  }

  input[type=text]:focus, input[type=file]:focus, input[type=password]:focus, input[type=email]:focus, select:focus {
    border: 1px solid #27A9E3;
  }

  input[type=submit], input[type=button] {
    display: inline-block;
    vertical-align: middle;
    padding: 12px 24px;
    margin: 0px;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    color: #ffffff;
    background-color: #27A9E3;
    border-radius: 3px;
    border: none;
    -webkit-appearance: none;
    outline: none;
    width: 100%;
  }


  .loginfromDiv{
    margin-left: 10%;
    width: 80%;
  }

</style>



// WEBPACK FOOTER //
// src/components/kjfx/login/UserLogin.vue